import React from 'react'

import { NoImageContent, TopImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Trends: React.FC<SectionProps> = ({ copy }) => (
  <React.Fragment>
    <TopImageContent
      altImage={copy.trends_widget_overview.widget_overview_alt_image}
      content={
        <React.Fragment>
          <Text content={copy.trends_widget_overview.widget_overview_description} />
          <List
            items={[
              buildDynamicCopy(
                copy.trends_widget_overview.widget_overview_y_axis_instruction,
                <b>{copy.trends_widget_overview.widget_overview_y_axis_bold}</b>,
              ) as React.ReactNode,
              buildDynamicCopy(
                copy.trends_widget_overview.widget_overview_x_axis_instruction,
                <b>{copy.trends_widget_overview.widget_overview_x_axis_bold}</b>,
              ) as React.ReactNode,
              buildDynamicCopy(
                copy.trends_widget_overview.widget_overview_colored_sections_instruction,
                <b>{copy.trends_widget_overview.widget_overview_colored_sections_bold}</b>,
              ) as React.ReactNode,
            ]}
          />
        </React.Fragment>
      }
      image={HELP_IMAGES.TRENDS_WIDGET}
      imageLargeBreakPoint={10}
      sx={{ pt: 24 }}
    />

    <NoImageContent
      content={
        <React.Fragment>
          <SectionTitle content={copy.trends_widget_overview.exploring_trends_title} />
          <List
            items={[
              copy.trends_widget_overview.exploring_trends_instruction_1,
              copy.trends_widget_overview.exploring_trends_instruction_2,
              copy.trends_widget_overview.exploring_trends_instruction_3,
              copy.trends_widget_overview.exploring_trends_instruction_4,
            ]}
          />
        </React.Fragment>
      }
      sx={{ pt: 48 }}
    />

    <NoImageContent
      content={
        <React.Fragment>
          <SectionTitle content={copy.trends_widget_overview.list_view_title} />
          <Text content={copy.trends_widget_overview.list_view_description} />
          <List
            items={[
              copy.trends_widget_overview.list_view_instruction_1,
              copy.trends_widget_overview.list_view_instruction_2,
            ]}
          />
        </React.Fragment>
      }
      hasDivider={false}
      sx={{ pt: 48 }}
    />
  </React.Fragment>
)

export default Trends
